import {gql} from '@apollo/client'

export const GET_USER = gql`
  query GetUser($userId: ID!) {
    user(id: $userId) {
      id
      accounts {
        id
        name
      }
      firstName
      lastName
      fullName @client
      displayName @client
      email
      createdAt
      lastSignInAt
      accessRevokedAt
      invitedBy
      invitationSentAt
      invitationAcceptedAt
      resetPasswordSentAt
    }
  }
`

export const CREATE_USER = gql`
  mutation CreateUser(
    $firstName: String
    $lastName: String
    $email: String
    $sendInvitation: Boolean
    $accountIds: [ID!]
  ) {
    user(
      firstName: $firstName
      lastName: $lastName
      email: $email
      sendInvitation: $sendInvitation
      accountIds: $accountIds
    ) {
      id
      firstName
      lastName
      fullName @client
      displayName @client
      email
      accounts {
        name
      }
      invitationSentAt
      accessRevokedAt
      lastSignInAt
    }
  }
`

export const UPDATE_USER = gql`
  mutation UpdateUser(
    $userId: ID!
    $firstName: String
    $lastName: String
    $accessRevoked: Boolean
    $accountIds: [ID!]
  ) {
    user(
      id: $userId
      firstName: $firstName
      lastName: $lastName
      accessRevoked: $accessRevoked
      accountIds: $accountIds
    ) {
      id
      accounts {
        id
        name
      }
      firstName
      lastName
      accessRevokedAt
    }
  }
`

export const SEND_USER_INVITATION = gql`
  mutation SendUserInvitation($userId: ID!) {
    sendUserInvitation(id: $userId) {
      id
      invitationSentAt
    }
  }
`
